
export const mobileWidth = 1025; //769;
export const mobileHeight = 680;
export const smallMobileWidth = 852; //pixel5 width is 851, iphone 12 pro 844, ipad air 1180, ipad mini 1024, smasung galaxy a51/71 914
 //769;

// export const DOMAIN = process.env.PUBLIC_URL + '/';// './'; // 'https://beechworth.herokuapp.com/';
export const DOMAIN = './';
// export const BASE_API = DOMAIN + 'api/v1/data/';
export const BASE_API = DOMAIN + 'data/';
export const ASSETS_API = './';
export const API = {
  INTRO: BASE_API + 'introduction.json',
  FEATURES: BASE_API + 'features.json',
  CREDITS: BASE_API + 'credits.json',
  FIVE: BASE_API + 'five.json',
  TEN: BASE_API + 'ten.json',
  TWENTY: BASE_API + 'twenty.json',
  FIFTY: BASE_API + 'fifty.json',
  HUNDRED: BASE_API + 'hundred.json',
  HELP: BASE_API + 'help.json',
}
// google analytics id
// export const GA_ID = "UA-000000-01";
export const GA_ID = "GTM-TC6S9RZ"; // using google tag manager

export const HEADERS = { headers: { 'Access-Control-Allow-Origin': DOMAIN } }

export const SECTIONS = {
  INTRO: "Introduction",
  FIVE: "$5",
  TEN: "$10",
  TWENTY: "$20",
  FIFTY: "$50",
  HUNDRED: "$100",
};

export const MEDIA = {
  INTRO: {
    sound:ASSETS_API+"sounds/1085.mp3",
    background:BASE_API+"intro/00_Introduction_720p.mp4",
    background_poster:BASE_API+"intro/00_Introduction.jpg",
    overlay:BASE_API+"assets_5D/bg_overlay_5D.png"
  },
  FIVE: {
    note:BASE_API+"assets_5D/5D_main_1.png",
    note_size:{width:600,height:300},
    note_reverse:BASE_API+"assets_5D/5D_main_2.png",
    note_choose:BASE_API+"assets_5D/5D_choose_note.png",
    background:BASE_API+"assets_5D/5D_background_plain_animated_720p.mp4",
    background_poster:BASE_API+"assets_5D/5D_background_plain_animated.jpg",
    background_clouds:BASE_API+"assets_5D/5D_background_main_animated_720p.mp4",
    background_clouds_poster:BASE_API+"assets_5D/5D_background_main_animated.jpg",
    background_cultural:BASE_API+"assets_5D/5D_background_cultural_720p.mp4",
    background_cultural_poster:BASE_API+"assets_5D/5D_background_cultural.jpg",
    background_security:BASE_API+"assets_5D/5D_background_security_720p.mp4",
    background_security_poster:BASE_API+"assets_5D/5D_background_security.jpg",
    note_feature_cultural:BASE_API+"assets_5D/5D_cultural_constitution.png",
    note_feature_security:BASE_API+"assets_5D/5D_security_flyingbird.png",
    sound:ASSETS_API+"sounds/1085.mp3",
    overlay:BASE_API+"assets_5D/bg_overlay_5D.png"
  },
  TEN: {
    note:BASE_API+"assets_10D/10D_main_1.png",
    note_size:{width:632,height:300},
    note_reverse:BASE_API+"assets_10D/10D_main_2.png",
    note_choose:BASE_API+"assets_10D/10D_choose_note.png",
    background:BASE_API+"assets_10D/10D_background_plain.mp4",
    background_poster:BASE_API+"assets_10D/10D_background_plain.jpg",
    background_clouds:BASE_API+"assets_10D/10D_background_main.mp4",
    background_clouds_poster:BASE_API+"assets_10D/10D_background_main.jpg",
    background_cultural:BASE_API+"assets_10D/10D_background_cultural.mp4",
    background_cultural_poster:BASE_API+"assets_10D/10D_background_cultural.jpg",
    background_security:BASE_API+"assets_10D/10D_background_security.mp4",
    background_security_poster:BASE_API+"assets_10D/10D_background_security.jpg",
    note_feature_cultural:BASE_API+"assets_10D/10D_cultural_banjopatterson.png",
    note_feature_security:BASE_API+"assets_10D/10D_security_3Dpen.png",
    sound:ASSETS_API+"sounds/1085.mp3",
    overlay:BASE_API+"assets_10D/bg_overlay_10D.png"
  },
  TWENTY: {
    note:BASE_API+"assets_20D/20D_main_1.png",
    note_size:{width:665,height:300},
    note_reverse:BASE_API+"assets_20D/20D_main_2.png",
    note_choose:BASE_API+"assets_20D/20D_choose_note.png",
    background:BASE_API+"assets_20D/20D_background_plain.mp4",
    background_poster:BASE_API+"assets_20D/20D_background_plain.jpg",
    background_clouds_poster:BASE_API+"assets_20D/20D_background_main.jpg",
    background_clouds:BASE_API+"assets_20D/20D_background_main.mp4",
    background_cultural:BASE_API+"assets_20D/20D_background_cultural.mp4",
    background_cultural_poster:BASE_API+"assets_20D/20D_background_cultural.jpg",
    background_security:BASE_API+"assets_20D/20D_background_security.mp4",
    background_security_poster:BASE_API+"assets_20D/20D_background_security.jpg",
    note_feature_cultural:BASE_API+"assets_20D/20D_cultural_bird.png",
    note_feature_security:BASE_API+"assets_20D/20D_security_3Dcompass.png",
    sound:ASSETS_API+"sounds/1085.mp3",
    overlay:BASE_API+"assets_20D/bg_overlay_20D.png"
  },
  FIFTY: {
    note:BASE_API+"assets_50D/50D_main_1.png",
    note_size:{width:697,height:300},
    note_reverse:BASE_API+"assets_50D/50D_main_2.png",
    note_choose:BASE_API+"assets_50D/50D_choose_note.png",
    background:BASE_API+"assets_50D/50D_background_plain.mp4",
    background_poster:BASE_API+"assets_50D/50D_background_plain.jpg",
    background_clouds:BASE_API+"assets_50D/50D_background_main.mp4",
    background_clouds_poster:BASE_API+"assets_50D/50D_background_main.jpg",
    background_cultural:BASE_API+"assets_50D/50D_background_cultural.mp4",
    background_cultural_poster:BASE_API+"assets_50D/50D_background_cultural.jpg",
    background_security:BASE_API+"assets_50D/50D_background_security.mp4",
    background_security_poster:BASE_API+"assets_50D/50D_background_security.jpg",
    note_feature_cultural:BASE_API+"assets_50D/50D_cultural_bird.png",
    note_feature_security:BASE_API+"assets_50D/50D_security_3Dbook.png",
    sound:ASSETS_API+"sounds/1085.mp3",
    overlay:BASE_API+"assets_50D/bg_overlay_50D.png"
  },
  HUNDRED: {
    note:BASE_API+"assets_100D/100D_main_1.png",
    note_size:{width:729,height:300},
    note_reverse:BASE_API+"assets_100D/100D_main_2.png",
    note_choose:BASE_API+"assets_100D/100D_choose_note.png",
    background:BASE_API+"assets_100D/100D_background_plain.mp4",
    background_poster:BASE_API+"assets_100D/100D_background_plain.jpg",
    background_clouds:BASE_API+"assets_100D/100D_background_main.mp4",
    background_clouds_poster:BASE_API+"assets_100D/100D_background_main.jpg",
    background_cultural:BASE_API+"assets_100D/100D_background_cultural.mp4",
    background_cultural_poster:BASE_API+"assets_100D/100D_background_cultural.jpg",
    background_security:BASE_API+"assets_100D/100D_background_security.mp4",
    background_security_poster:BASE_API+"assets_100D/100D_background_security.jpg",
    note_feature_cultural:BASE_API+"assets_100D/100D_cultural_bird.png",
    note_feature_security:BASE_API+"assets_100D/100D_security_3Dbook.png",
    sound:ASSETS_API+"sounds/1085.mp3",
    overlay:BASE_API+"assets_100D/bg_overlay_100D.png"
  },
};

export const FEATURES = {
  CULTURAL: "Cultural features",
  SECURITY: "Design and security features",
  CULTURAL_DATA_LABEL: "Cultural feature",
  SECURITY_DATA_LABEL: "Design and Security feature"
};